import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var StarHalf = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m42.512 16.246-14.106-.599-4.902-13.179a1.528 1.528 0 0 0-2.901 0L15.7 15.648l-14.206.598c-1.5.1-2 1.897-.9 2.796l11.004 8.786-3.801 13.578c-.4 1.398 1.2 2.496 2.4 1.797l11.805-7.887 11.705 7.788c1.2.798 2.801-.3 2.401-1.698l-3.801-13.578 11.004-8.786c1.3-.899.6-2.696-.8-2.796ZM30.907 26.43c-.5.4-.7.999-.5 1.697l3.601 12.78-11.004-7.288V6.86l3.701 9.785c.2.599.8.998 1.4.998l13.306.6-10.504 8.186Z"
  }));
});
StarHalf.displayName = 'StarHalf';
StarHalf.defaultProps = {
  'aria-label': 'StarHalf'
};
export default StarHalf;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/StarHalf.js
// module id = 3290
// module chunks = 11